import { ConfigurationRouting } from './ConfigurationRouting';

export const ConfigurationModule = () => {
  return <ConfigurationRouting />;
};
